
import { AxiosInstance, AxiosResponse } from "axios"
import api from "@/services/api"
import { Report, ReportDetails } from "@/types/report"

class ReportsApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async reportGetList (): Promise<Report[]> {
		return (await this.axios.get("/report")).data
	}

	public async reportGet (reportId: string): Promise<ReportDetails> {
		return (await this.axios.get(`/report/${reportId}`)).data
	}

	public async reportSave (report: ReportDetails): Promise<ReportDetails> {
		return (await this.axios.post("/report", report)).data
	}

	public async reportDelete (reportId: string): Promise<void> {
		await this.axios.delete(`/report/${reportId}`)
	}

	public async downloadReportById (reportId: string, reportTitle: string | null) {
		const response = await this.axios.get(`/report/generate/${reportId}`, {
			responseType: "arraybuffer"
		})

		this.download(response, reportTitle + ".pdf")
	}

	public async downloadReport (report: ReportDetails) {
		const response = await this.axios.post("/report/generate", report, {
			responseType: "arraybuffer"
		})

		this.download(response, (report.title || "Report") + ".pdf")
	}

	public async triggerReportEmails (report: ReportDetails) {
		return this.axios.post("/report/triggerReportEmails", report)
	}

	private download (response: AxiosResponse, fileName: string) {
		const link = document.createElement("a")
		link.href = window.URL.createObjectURL(new Blob([response.data]))
		link.setAttribute("download", fileName)

		document.body.appendChild(link)
		link.click()
	}
}

const reportsApi = new ReportsApi()
export default reportsApi
